import { render } from "./PagamentoTypeBadge.vue?vue&type=template&id=3178d975"
import script from "./PagamentoTypeBadge.vue?vue&type=script&lang=js"
export * from "./PagamentoTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__